import { mapGetters } from 'vuex'
export default {
  props: {
    checkCustomerType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCustomerTypePrompt: false,
    }
  },
  computed: {
    ...mapGetters({
      hasCustomerType: 'quote/hasCustomerType',
    }),
  },
  methods: {
    customerTypeCheck() {
      if (this.checkCustomerType) {
        if (!this.hasCustomerType) {
          this.showCustomerTypePrompt = true
          return false
        }
      }
      return true
    },
  },
}
